import React from "react";

import { UploadSpreadSheetUnsupportedFile } from "./UploadSpreadSheetUnsupportedFile";
import { UploadSpreadSheetLoadingInfo } from "./UploadSpreadSheetLoadingInfo";
import { UploadSpreadSheetErrors } from "./UploadSpreadSheetErrors";
import { UploadSpreadSheetClearErrors } from "./UploadSpreadSheetClearErrors";

const UploadSpreadSheet = () => {
  return (
    <>
      <UploadSpreadSheetLoadingInfo />
      <UploadSpreadSheetUnsupportedFile />
      <UploadSpreadSheetErrors />
      <UploadSpreadSheetClearErrors />
    </>
  );
};

export { UploadSpreadSheet };
